// extracted by css-extract-rspack-plugin
export default {"sectionTitle":"PP_6RGqvIx01eCCk","emptyState":"Xa8kbO5ClszAIPG1"};